export const staff = [
  // DEVELOPERS
  {
    life: 500,
    path: "/match3-game/profiles/v1.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v2.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v3.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v4.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v5.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v6.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v7.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v8.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v9.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v10.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v11.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v12.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v13.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v14.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v15.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v16.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v17.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v18.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v19.jpg",
    fullName: "Full Name",
    category: "⚔️ Warriors - Developers",
    color: "green",
    desc: "Build features and squash bugs.",
  },
  // DEVOPS/IT/DATA
  {
    life: 500,
    path: "/match3-game/profiles/v20.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v21.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v22.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v23.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v24.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v25.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v26.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v27.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v28.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v29.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v30.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v31.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v32.jpg",
    fullName: "Full Name",
    category: "⛏️ Dwarves - DeveOps/IT/DATA",
    color: "red",
    desc: "Deploy and maintain infrastructure.",
  },
  // FINANCE/HR
  {
    life: 500,
    path: "/match3-game/profiles/v33.jpg",
    fullName: "Full Name",
    category: "💰 Hobbits - Finance/HR",
    color: "purple",
    desc: "Manage budgets and resources.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v34.jpg",
    fullName: "Full Name",
    category: "💰 Hobbits - Finance/HR",
    color: "purple",
    desc: "Manage budgets and resources.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v35.jpg",
    fullName: "Full Name",
    category: "💰 Hobbits - Finance/HR",
    color: "purple",
    desc: "Manage budgets and resources.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v36.jpg",
    fullName: "Full Name",
    category: "💰 Hobbits - Finance/HR",
    color: "purple",
    desc: "Manage budgets and resources.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v37.jpg",
    fullName: "Full Name",
    category: "💰 Hobbits - Finance/HR",
    color: "purple",
    desc: "Manage budgets and resources.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v38.jpg",
    fullName: "Full Name",
    category: "💰 Hobbits - Finance/HR",
    color: "purple",
    desc: "Manage budgets and resources.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v39.jpg",
    fullName: "Full Name",
    category: "💰 Hobbits - Finance/HR",
    color: "purple",
    desc: "Manage budgets and resources.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v40.jpg",
    fullName: "Full Name",
    category: "💰 Hobbits - Finance/HR",
    color: "purple",
    desc: "Manage budgets and resources.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v41.jpg",
    fullName: "Full Name",
    category: "💰 Hobbits - Finance/HR",
    color: "purple",
    desc: "Manage budgets and resources.",
  },
  // UX/UI
  {
    life: 500,
    path: "/match3-game/profiles/v42.jpg",
    fullName: "Full Name",
    category: "🧝🏻 Elves - UX/UI",
    color: "darkblue",
    desc: "Design delightful experiences.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v43.jpg",
    fullName: "Full Name",
    category: "🧝🏻 Elves - UX/UI",
    color: "darkblue",
    desc: "Design delightful experiences.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v44.jpg",
    fullName: "Full Name",
    category: "🧝🏻 Elves - UX/UI",
    color: "darkblue",
    desc: "Design delightful experiences.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v45.jpg",
    fullName: "Full Name",
    category: "🧝🏻 Elves - UX/UI",
    color: "darkblue",
    desc: "Design delightful experiences.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v46.jpg",
    fullName: "Full Name",
    category: "🧝🏻 Elves - UX/UI",
    color: "darkblue",
    desc: "Design delightful experiences.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v47.jpg",
    fullName: "Full Name",
    category: "🧝🏻 Elves - UX/UI",
    color: "darkblue",
    desc: "Design delightful experiences.",
  },
  // PMs/TMs
  {
    life: 500,
    path: "/match3-game/profiles/v48.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v49.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v50.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v51.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v52.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v53.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v54.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v55.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v56.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v57.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v58.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v59.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v60.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v61.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v62.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
  {
    life: 500,
    path: "/match3-game/profiles/v63.jpg",
    fullName: "Full Name",
    category: "🧙 Wizards - PMs/TMs",
    color: "yellow",
    desc: "Coordinate teams and schedules.",
  },
];

export const projects = [
  {
    life: 3000,
    path: "/match3-game/enemies/v1.jpg",
    fullName: "EEA Project",
    color: "green",
    desc: "Quick initiative requiring few resources.",
  },
  {
    life: 5000,
    path: "/match3-game/enemies/v2.jpg",
    fullName: "CJBS Project",
    color: "orange",
    desc: "Balanced effort across the company.",
  },
  {
    life: 8000,
    path: "/match3-game/enemies/v3.jpg",
    fullName: "Enisa Project",
    color: "blue",
    desc: "Major undertaking with high stakes.",
  },
];

